import Vue from "vue";
import Router from "vue-router";

// factory
import AiDiseasePrediction from "./factory/AiDiseasePrediction/AiDiseasePrediction.vue";

// views
import KaradaNotebook from "./views/KaradaNotebook.vue";
import DiseasePredictionReport from "./views/DiseasePredictionReport.vue";
import RepoertDiscription from "./views/RepoertDiscription.vue";
import ResultList from "./views/ResultList.vue";
import KaradaKarte from "./views/KaradaKarte.vue";

import Notes from "./views/Notes.vue";
import CardInformation from "./components/molecules/CardInformation/CardInformation.vue";
import CouponTicket from "./views/CouponTicket.vue";
import AccountInfoInput from "./views/AccountInfoInput.vue";
import Login from "./views/Login.vue";
import RegisterComplete from "./views/RegisterComplete.vue";
//import CsvUpload from "./views/CsvUpload.vue";
import SelectPayment from "./views/SelectPayment.vue";
import SignIn from "./views/SignIn.vue";
import SignUp from "./views/SignUp.vue";
//import WellchoSignIn from "./views/WellchoSignIn.vue";
import Reset from "./views/Reset.vue";
import errorPage from "./views/Error.vue";
import emptyPage from "./views/404.vue";
import test from "./views/InputContentConfirmation.vue";

import { firebase, auth } from "./firebase";
import store from "./store";

Vue.use(Router);

const RouterVue = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // スクロール位置を調整するやつ
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "loading",
      component: SignIn,
    },
    {
      path: "/SignIn",
      name: "signIn",
      component: SignIn,
    },
    {
      path: "/SignUp",
      name: "SignUp",
      component: SignUp,
    },
    /*{
      path: "/Wellcho/SignIn",
      name: "WellchoSignIn",
      component: WellchoSignIn
    },*/
    {
      path: "/Reset",
      name: "Reset",
      component: Reset,
    },
    {
      path: "/AI-Diesease-Prediction",
      name: "diesease",
      component: AiDiseasePrediction,
      meta: { requiresAuth: true },
    },
    {
      path: "/Karada-Diary",
      name: "notebook",
      component: KaradaNotebook,
      meta: { requiresAuth: true },
    },
    {
      path: "/Report",
      name: "report",
      component: DiseasePredictionReport,
      meta: { requiresAuth: true },
    },
    {
      path: "/Report-discription",
      name: "report-discription",
      component: RepoertDiscription,
      meta: { requiresAuth: true },
      props: (route) => ({
        index: String(route.params.index),
      }),
    },
    {
      path: "/notes",
      name: "notes",
      component: Notes,
      meta: { requiresAuth: true },
    },
    {
      path: "/card",
      name: "card",
      component: CardInformation,
      meta: { requiresAuth: true },
    },
    {
      path: "/coupon",
      name: "coupon",
      component: CouponTicket,
      meta: { requiresAuth: true },
    },
    {
      path: "/account-info",
      name: "account",
      component: AccountInfoInput,
      meta: { requiresAuth: true },
      props: (route) => ({
        source: String(route.params.source),
      }),
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { requiresAuth: true },
    },
    {
      path: "/register-complete",
      name: "complete",
      component: RegisterComplete,
      meta: { requiresAuth: true },
    },
    {
      path: "/test",
      name: "test",
      component: test,
    },
    {
      path: "/result-list",
      name: "resultList",
      component: ResultList,
    },
    {
      path: "/karada-karte",
      name: "karadaKarte",
      component: KaradaKarte,
    },
    /*
    {
      path: "/csv-upload",
      name: "csvUpload",
      component: CsvUpload
    },*/
    {
      path: "/select-payment",
      name: "selectPayment",
      component: SelectPayment,
      meta: { requiresAuth: true },
    },
    {
      path: "/Error",
      name: "error",
      component: errorPage,
    },
    {
      path: "*",
      name: "empty",
      component: emptyPage,
    },
  ],
});

RouterVue.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // すでに認証済みの場合は遷移
    if (auth.currentUser && auth.currentUser.emailVerified) {
      store.dispatch("auth/onAuthStateChanged", auth.currentUser);
      store.dispatch("auth/onUserStatusChanged", true);

      // Firebase からユーザデータを取得しているか確認する
      if (store.state.users.nickname) {
        // storeに存在している場合は該当の画面に遷移する
        next();
      } else {
        try {
          // FireBase Auth チェック
          const checkUser = firebase.functions().httpsCallable("checkUser");
          await checkUser();
          // Firebase 認証が完了している場合はユーザ情報を取得する
          const { uid } = auth.currentUser;
          await store.dispatch("users/fetchUserFromFirebase", uid);
          next();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log("ERROR", error);
          store.dispatch("clearAll");
          // 認証されていないためSignIn画面に移動
          next("/SignIn");
        }
      }
      return;
    }
    auth.onAuthStateChanged((user) => {
      if (user && user.emailVerified) {
        store.dispatch("auth/onAuthStateChanged", user);
        store.dispatch("auth/onUserStatusChanged", true);
        next();
      } else {
        store.dispatch("auth/onAuthStateChanged", {});
        store.dispatch("auth/onUserStatusChanged", false);
        // 認証されていないためSignIn画面に移動
        next("/SignIn");
      }
      return;
    });
  } else {
    next();
  }
});

export default RouterVue;
